<template>
<div class="chapter">
<div class="inner_page">
<p class="imgpart"><a id="page_8"></a><a id="page_9"><img alt="Image" src="images/part.jpg"/></a></p><a id="page_9">
<h2 class="h2part"><span class="txbf">PART 1</span></h2>
<h2 class="h2psub">SIGNS, ELEMENTS,</h2>
<h2 class="h2psub">______ <span class="smallcaps">AND</span> ______</h2>
<h2 class="h2psub">SELF-CARE</h2>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?d919438c